//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { computed } from "@nuxtjs/composition-api";
import blokProp from "~/helpers/blok-prop";
const __sfc_main = {};
__sfc_main.props = blokProp;

__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const paragraphs = computed(() => props.blok.paragraphs.content?.filter(({
    content
  }) => content));
  const statistics = computed(() => props.blok.statistics.filter(({
    description,
    number
  }) => description || number));
  return {
    paragraphs,
    statistics
  };
};

export default __sfc_main;
